<template>
  <div id="AI_assistant" class="AI_assistant mx-auto">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="block px-3 cursor-pointer" @click="toTop('#plan1')">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar_02.png" class="off object-contain">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar-off_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan3')">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar_03.png" class="off object-contain">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar-off_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#AI_assistant')">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar_04.png" class="off object-contain">
        <img src="~@/assets/images/AI_assistant/menu/menu-bar-off_04.png" class="on object-contain">
      </a>
    </div>
    <div class="banner mb-6">
      <div class="banner_inner hidden md:block relative">
        <div class="py-6">
          <img src="~@/assets/images/AI_assistant/Hearder.png" class="object-contain mx-auto">
        </div>
        <div class="absolute top-0 z-10">
          <img src="~@/assets/images/AI_assistant/Intersect.png" class="object-contain">
        </div>
      </div>
      <div class="banner_inner_m mx-auto md:hidden py-6">
        <img src="~@/assets/images/AI_assistant/m/Hearder-01-m.png" class="object-contain">
        <img src="~@/assets/images/AI_assistant/m/Hearder-02-m.png" class="object-contain">
      </div>
    </div>

    <div class="p-4 md:p-0 mb-6" id="plan1">
      <img src="~@/assets/images/AI_assistant/Order-step.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/Order-step-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6" id="plan2">
      <img src="~@/assets/images/AI_assistant/Price-List.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/Price-List-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6">
      <img src="~@/assets/images/AI_assistant/info-01.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/info-01-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6">
      <img src="~@/assets/images/AI_assistant/info-02.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/info-02-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6" id="plan3">
      <img src="~@/assets/images/AI_assistant/Product-Title.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/Product-Title-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6">
      <img src="~@/assets/images/AI_assistant/AI-SPEAK-01.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/AI-SPEAK-01-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6">
      <img src="~@/assets/images/AI_assistant/AI-WRITER-02.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/AI-WRITER-02-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="p-4 md:p-0 mb-6">
      <img src="~@/assets/images/AI_assistant/AI-TEST-ROOM-03.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/AI-TEST-ROOM-03-m.png" class="object-contain mx-auto md:hidden">
    </div>

    <a class="p-4 md:py-6 block" href="https://store.liveabc.com/products/digital?category=221" target="_blank">
      <img src="~@/assets/images/AI_assistant/Order-now.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/AI_assistant/m/Order-now.png" class="object-contain mx-auto md:hidden">
    </a>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'AI_assistant',
  metaInfo () {
    return {
      title: 'AI英語學習教室',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  .banner_inner_m {
    background: linear-gradient(0deg, #5A5D9B, #5A5D9B), linear-gradient(180deg, #8A89F5 0%, rgba(138, 137, 245, 0) 100%);
    background-size: 100vw, 80vh;
    background-position: top center;
  }
}
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
.max-w-scoped {
  max-width: 1120px;
}
.bg-light-blue {
  background-color: #EFF6FF;
}
.shadow_line {
  box-shadow: 0px 4px 4px 0px #00000040;
}
.advantage_img {
  left: 1%;
}
.left_line {
  &:before {
    content: "";
    display: block;
    top: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    background: #B2CCFF;
    height: 100%;
    width: 4px;
  }
  &:after {
    content: "";
    display: block;
    bottom: -2%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;

    background: #B2CCFF;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    @media (max-width: 640px) {
      height: 25px;
      width: 25px;
      bottom: -1%;
    }
  }
  .left_line_class {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90px;
    height: 90px;
    @media (max-width: 640px) {
      width: 80px;
      height: 80px;
    }
  }
  .left_line_title {
    bottom: 25%;
    left: 50%;
    transform: translateX(-50%);
  }
}

.footer {
  background-image: url('~@/assets/images/SHUWOON/footer_bg.png');
  background-size: contain;
}
</style>
